import React from "react";
import { Badge } from "../design/badge";
import { MatterType } from "../models/MatterType";

interface MatterTypeBadgeProps {
  matterType?: MatterType;
}

const MatterTypeBadge: React.FC<MatterTypeBadgeProps> = ({ matterType }) => {
  console.log("matterType", matterType);
  return <Badge color={"red"}>{matterType?.name ?? matterType?._id}</Badge>;
};

export default MatterTypeBadge;
